import { Component } from '@theme/component';
import { RebuyInitEvent, RebuyCartChangeEvent } from '@theme/events';

/**
 * A custom element that manages the main menu drawer.
 *
 * @typedef {object} Refs
 * @property {HTMLDetailsElement} details - The details element.
 *
 * @extends {Component<Refs>}
 */
class HeaderActions extends Component {

  connectedCallback() {
    super.connectedCallback();

    this.rebuyInitialized = false
    this.athleteItemId = this.dataset.athleteItemId

    document.addEventListener(RebuyInitEvent.eventName, this.onRebuyInit.bind(this));
    document.addEventListener(RebuyCartChangeEvent.eventName, this.onCartUpdate.bind(this));
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener(RebuyInitEvent.eventName, this.onRebuyInit);
    document.removeEventListener(RebuyCartChangeEvent.eventName, this.onCartUpdate);
  }

  get isLoopOnActive () {
    return window.LoopOnstore && window.LoopOnstore.isActive()
  }

  onRebuyInit () {
    this.rebuyInitialized = true

    setTimeout(() => {
      this.validateAtheletePass()
    }, 1000)
  }

  onCartUpdate () {
    setTimeout(() => {
      this.validateAtheletePass()
    }, 1000)
  }

  async validateAtheletePass () {
    const { SmartCart, Cart } = window.Rebuy;

    const items = (SmartCart?.cart?.items || []).filter(item => !(item.properties && item.properties._is_athlete_pass))
      .filter(item => item.requires_shipping);

    const athleteInCart = (SmartCart?.cart?.items || []).filter(item => item.properties && item.properties._is_athlete_pass)
      .map(item => item.quantity)
      .reduce((a, b) => a + b, 0)

    if (items.length > 0 && athleteInCart === 0 && !!this.athleteItemId && !this.isLoopOnActive) {
      await Cart.addItem({
        items: [
          {
            id: this.athleteItemId,
            quantity: 1,
            properties: {
              _is_athlete_pass: true
            }
          }
        ]
      })
    }

    if ((athleteInCart > 0 && items.length === 0) || this.isLoopOnActive) {
      const athlete = SmartCart.cart.items.find(item => item.properties && item.properties._is_athlete_pass)
      if (!!athlete) {
        await Rebuy.Cart.changeItem({
          id: athlete.key,
          quantity: 0
        })
      }
    }

    if (athleteInCart > 1 && !this.isLoopOnActive) {
      const athlete = SmartCart.cart.items.find(item => item.properties && item.properties._is_athlete_pass)

      await Rebuy.Cart.changeItem({
        id: athlete.key,
        quantity: 1
      })
    }

  }
}

if (!customElements.get('header-actions')) {
  customElements.define('header-actions', HeaderActions);
}